import _ from 'lodash';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function OurCommitments({ data, id }) {
  const title = _.get(data, 'commitmentTitle', '');
  const text = _.get(data, 'commitmentText', '');
  const items = _.get(data, 'items', null);
  return (
    <section id={id} className="bg-[#F7F7F7] py-[50px] md:py-[100px]">
      <div className="container max-w-[1200px] mx-auto px-6">
        <div className="max-w-[770px] text-center mx-auto pb-2 md;pb-5">
          <h2 className="text-clamp22to30 mb-4 text-[#4A4A4A]">{title}</h2>
          <div className="font-DINRegular" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        {_.isEmpty(items) || (
          <div className="flex flex-row flex-wrap gap-6 md:gap-[30px] justify-center">
            {_.map(items, (item, index) => (
              <div
                key={index}
                className="md:max-w-[calc(33.3333%-20px)] flex flex-col gap-3
                md:gap-5 items-center">
                {_.isEmpty(item.content.commitmentItemIcon) || (
                  <LazyLoadImage
                    src={item.content.commitmentItemIcon.url}
                    alt={item.content.commitmentItemTitle}
                    className="w-[72px] h-[70px] object"
                  />
                )}
                <h3 className="text-clamp16to20 leading-1.5 mb-0 text-[#4A4A4A]">
                  {item.content.commitmentItemTitle}
                </h3>
                <div
                  className="font-DINRegular p-child:!mb-0 text-center"
                  dangerouslySetInnerHTML={{ __html: item.content.commitmentItemText }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
